import { trackMonitoringAlarmCarouselTabClick } from '@ecomm/cdp-tracking'
import type { ReactNode } from 'react'
import { useState } from 'react'
import { AlarmMomentsCta } from './AlarmMomentsCta'
import { AlarmMomentsHeader } from './AlarmMomentsHeader'
import { AlarmMomentsNavigationButton } from './AlarmMomentsNavigationButton'
import { useOnSelectAlarmMoment } from './useOnSelectAlarmMoment'

export type AlarmMomentsTabProps = {
  readonly label: string
  readonly title: string
  readonly description: string
  readonly tab: ReactNode
}

export type AlarmMomentsProps = {
  readonly tabs: ReadonlyArray<AlarmMomentsTabProps>
  readonly cta?: { readonly text: string; readonly url: string }
  readonly headlineClass?: string
}

export function AlarmMoments({ tabs, cta, headlineClass }: AlarmMomentsProps) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const selectedTab = tabs[selectedIndex]
  const onSelectAlarmMoment = useOnSelectAlarmMoment()

  const handleSelectAlarmMoment = (carouselTab: number) => () => {
    onSelectAlarmMoment(carouselTab)
    trackMonitoringAlarmCarouselTabClick(carouselTab)
    setSelectedIndex(carouselTab)
  }

  return (
    <div
      className="flex flex-col items-center justify-center"
      data-component="AlarmMomentsV2"
      data-testid="AlarmMomentsV2"
    >
      {selectedTab && (
        <AlarmMomentsHeader
          title={selectedTab.title}
          description={selectedTab.description}
          className={headlineClass}
        />
      )}
      {tabs.length > 1 && (
        <div
          className="inset-x-1/2 flex w-screen justify-center"
          style={{ marginLeft: '-50vw', marginRight: '-50vw' }}
        >
          <div className="flex items-center gap-2 overflow-x-auto p-2 pb-4">
            {tabs.map((tab, i) => (
              <AlarmMomentsNavigationButton
                isSelected={i === selectedIndex}
                key={tab.label}
                onClick={handleSelectAlarmMoment(i)}
                text={tab.label}
              />
            ))}
          </div>
        </div>
      )}
      {selectedTab?.tab}
      {cta && <AlarmMomentsCta text={cta.text} url={cta.url} />}
    </div>
  )
}
